<div class="header" [hidden]="creatorFocus.focus()">
  <div class="al-page-title">
    <a
      *ngIf="hasTask"
      class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
      routerLink="/creator"
      [attr.aria-label]="'pages.creator.backToStart' | translate"
      [nbTooltip]="'pages.creator.backToStart' | translate"
      nbTooltipPlacement="right"
    ><span class="al-relief-glyph" aria-hidden="true"></span></a>
    <h2>{{ "pages.creator.title" | translate }}</h2>
  </div>
  <span class="header__spacer"></span>
  <!-- Fokus-Layout pausiert („Navigation einblenden“), der Kurs-Editor ist noch offen -->
  <button
    *ngIf="creatorFocus.canResume()"
    type="button"
    class="al-button al-button--secondary"
    (click)="resumeFocus()"
  >
    <nb-icon icon="expand-outline"></nb-icon>
    {{ "pages.creator.fullscreen" | translate }}
  </button>
</div>

<nb-card class="iframe-card" [class.iframe-card--focus]="creatorFocus.focus()">
  <nb-card-body>
    <div *ngIf="iframeLoading" class="loading-container">
      <app-page-loader></app-page-loader>
      <p>{{ "pages.creator.loading" | translate }}</p>
    </div>
    <iframe
      *ngIf="iframeUrl"
      #myIframe
      [src]="iframeUrl | safe"
      [class.hidden]="iframeLoading"
      (load)="onIframeLoaded()"
      title="Alphabees Creator"
      allow="fullscreen; clipboard-read; clipboard-write; autoplay; encrypted-media; picture-in-picture"
    ></iframe>
  </nb-card-body>
</nb-card>

<!-- Fokus-Layout (ALPHABEES_LAYOUT): Kopf und Menü sind aus, das hier ist
     der Rückweg — auch wenn der Creator nicht mehr antwortet. -->
<button
  *ngIf="creatorFocus.focus()"
  type="button"
  class="al-button al-button--secondary focus-exit"
  (click)="endFocus()"
>
  <nb-icon icon="menu-outline"></nb-icon>
  {{ "pages.creator.showNavigation" | translate }}
</button>
